import { writable } from "svelte/store";
export const SESSION = writable({ logged: false });
export const EMPLOYEE_DETAILS = writable({});
export const EMPLOYEE_ROLES = writable({});
export const changeSessionState = logged => {
    SESSION.set({ logged });
};
